import { render, staticRenderFns } from "./StockMovements.vue?vue&type=template&id=7dac841d&scoped=true&"
import script from "./StockMovements.vue?vue&type=script&lang=js&"
export * from "./StockMovements.vue?vue&type=script&lang=js&"
import style0 from "./StockMovements.vue?vue&type=style&index=0&id=7dac841d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac841d",
  null
  
)

export default component.exports